import {
  HOME_GET_HOT_BY_POSITION_TYPE_BEGIN,
  HOME_GET_HOT_BY_POSITION_TYPE_SUCCESS,
  HOME_GET_HOT_BY_POSITION_TYPE_FAILURE,
  HOME_GET_HOT_BY_POSITION_TYPE_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getHotByPositionType(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: HOME_GET_HOT_BY_POSITION_TYPE_BEGIN,
    });
    const promise = new Promise((resolve, reject) => {
        request({
          method:'post',
          url:'/api/b/position/countHotByPositionType',
        }).then( data => {
            dispatch({
                type: HOME_GET_HOT_BY_POSITION_TYPE_SUCCESS,
                data: data,
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: HOME_GET_HOT_BY_POSITION_TYPE_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });

  
    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetHotByPositionTypeError() {
  return {
    type: HOME_GET_HOT_BY_POSITION_TYPE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_GET_HOT_BY_POSITION_TYPE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getHotByPositionTypePending: true,
        getHotByPositionTypeError: null,
      };

    case HOME_GET_HOT_BY_POSITION_TYPE_SUCCESS:
      // The request is success
      return {
        ...state,
        getHotByPositionTypePending: false,
        getHotByPositionTypeError: null,
        hotByPositionType:action.data,
      };

    case HOME_GET_HOT_BY_POSITION_TYPE_FAILURE:
      // The request is failed
      return {
        ...state,
        getHotByPositionTypePending: false,
        getHotByPositionTypeError: action.data.error,
      };

    case HOME_GET_HOT_BY_POSITION_TYPE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getHotByPositionTypeError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/getHotByPositionType.js